import { ISettingsModel } from "@pjs/user-domain";
import { IViewConfig } from "../interfaces/IViewConfig";
import { IUserDetails } from "../interfaces/IUserDetails";

export const mapAvailableViews = (
    factory: (userDetails: IUserDetails) => Array<Array<IViewConfig>>,
    userDetails: IUserDetails,
    accountSettings: ISettingsModel
): Array<Array<IViewConfig>> => {
    const views = factory(userDetails);
    return views.map((subViews) => subViews.filter((viewConfig) => viewConfig.isEnabled(userDetails, accountSettings)));
};
